import React from 'react'
import './styles.css'

export default (props) => {

  return(
    <fb className="dummyTasks">
      <fb className="dummyTask" style={{backgroundColor: '#d4d4d4'}}>...</fb>
      <fb className="dummyTask" style={{backgroundColor: '#dedede'}}>...</fb>
      <fb className="dummyTask" style={{backgroundColor: '#e6e6e6'}}>...</fb>
    </fb>
  )
}



// WEBPACK FOOTER //
// ./src/containers/apps/taskManager/calendar/day/dummyTasks/index.js